import springApi from '../../services/springApi'

export const storeExportToken = data => (
	new Promise((resolve, reject) => {
		springApi()
			.post('/export_tokens', data)	
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)